module.exports = __webpack_public_path__ + "img/seat.012e124.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/seat.png
// module id = 1098
// module chunks = 0